import Slider from "react-slick";
import {memo, useEffect, useRef, useState} from "react";

const NewSkillFinderDropdown = (props) => {
    const CarouselConfig = {
        swipeToSlide: true,
        dots: false,
        infinite: false,
        arrows: false,
        slidesToScroll: 1,
        slidesToShow: 1,
        beforeChange: (_, NewIdx) => handleSlideChange(NewIdx)
    }

    const SliderRef = useRef(null)
    const [IsPrevDisabled, setIsPrevDisabled] = useState(false)
    const [IsNextDisabled, setIsNextDisabled] = useState(false)

    const handleSlideChange = (currentIndex) => {
        const HasNextPage = currentIndex < props.SearchResults.length - 1
        const HasPrevPage = currentIndex !== 0

        setIsNextDisabled(!HasNextPage)
        setIsPrevDisabled(!HasPrevPage)
    }

    const handleScrollRecent = (direction) => {
        if (direction === 'right' && !IsNextDisabled) {
            SliderRef.current.slickNext()
        } else if (direction === 'left' && !IsPrevDisabled) {
            SliderRef.current.slickPrev()
        }
    }

    const getEmployeeInitial = (firstName, lastName) => {
        return firstName.slice(0,1) + lastName.slice(0,1)
    }

    useEffect(() => {
        handleSlideChange(0)
    }, [])

    return (
        <div className='skill-finder-result-wrapper'>
            <button
                className={`recent-row-switch left-arrow ${IsPrevDisabled && 'disabled'}`}
                onClick={() => handleScrollRecent("left")}
            >
                <i className="feather-chevron-left"></i>
            </button>
            <Slider ref={SliderRef} {...CarouselConfig}>
                {props.SearchResults?.map((Result, Idx) => (
                    <div key={Idx}>
                        <div className='skill-finder-result'>
                            <section className='skill-finder-result-title'>{Result.positionTitle}</section>

                            {/*employee info*/}
                            {Result.employees?.length > 0 ?
                                <section className='skill-finder-result-employee'>
                                    {Result.employees.slice(0, 3).map((employee, EmpIdx) => (
                                        <div className='employee-icon' key={EmpIdx}>
                                            {
                                                employee.imageThumbnailUrl ?
                                                    <img
                                                        src={employee.imageThumbnailUrl}
                                                        alt='emp-icon'
                                                    /> :
                                                    <div className='employee-icon_empty-url' style={{
                                                        backgroundColor: employee.backgroundColorCode,
                                                        color: employee.textColorCode,
                                                    }}>
                                                        {getEmployeeInitial(employee.firstName, employee.lastName)}
                                                    </div>
                                            }
                                            <p className='popup-text'>{employee.firstName} {employee.lastName}</p>
                                        </div>
                                    ))}
                                    {Result.employees?.length > 3 ?
                                        <div className='employee-icon'>
                                            <span className='others'>+{Result.employees.length - 3}</span>
                                        </div> :
                                        null}
                                </section>
                                : null}


                            {/*matching skills*/}
                            {
                                Result.matchingSkills?.length > 0 ?
                                    <section className='skill-finder-result-matching'>
                                        <div className='section-title'>{ props.translateText('initial_matching_skills') }</div>
                                        <div className='matching-skills'>
                                            {Result.matchingSkills?.map((MatchingSkill, Idx) => {
                                                const IsSelected = props.SelectedSkillIds.includes(MatchingSkill.id)
                                                return (
                                                    <span
                                                        key={Idx}
                                                        className={`matching-skills-chip ${IsSelected && 'selected'}`}
                                                        onClick={() => props.OnSelectSkill(MatchingSkill)}
                                                    >
                                            {MatchingSkill.title}
                                                        {IsSelected ? <i className='feather-check'/> : null}
                                    </span>
                                                )
                                            })}
                                        </div>
                                    </section> :
                                    null
                            }

                            {/*top 5 skills*/}
                            {
                                Result.topSkills?.length > 0 ?
                                    <section className='skill-finder-result-matching'>
                                        <div className='section-title'>{ props.translateText('position_top_5_skills') }</div>
                                        <div className='matching-skills'>
                                            {Result.topSkills?.map((TopSkill, Idx) => {
                                                const IsSelected = props.SelectedSkillIds.includes(TopSkill.id)
                                                return (
                                                    <span
                                                        key={Idx}
                                                        className={`matching-skills-chip ${IsSelected && 'selected'}`}
                                                        onClick={() => props.OnSelectSkill(TopSkill)}
                                                    >
                                            {TopSkill.title}
                                                        {IsSelected ? <i className='feather-check'/> : null}
                                    </span>
                                                )
                                            })}
                                        </div>
                                    </section> :
                                    null
                            }
                        </div>
                    </div>
                ))}
            </Slider>
            <button
                className={`recent-row-switch right-arrow ${IsNextDisabled && 'disabled'}`}
                onClick={() => handleScrollRecent("right")}
            >
                <i className="feather-chevron-right"></i>
            </button>
        </div>
    );
};

export default memo(NewSkillFinderDropdown);
